import React from "react";
import { Helmet } from "react-helmet";
import Main from "./Main";
import "./css/index.css";
import Family from "./Family";
import Feedback from "./Feedback";

function index() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>About Us</title>
        <meta
          name="description"
          content="We are a group of young passionate graduates dedicated to provide the platform to learn the skills that colleges not provide. We ignite the young minds to learn the skills right from college days."
        />
      </Helmet>
      <Main />
      <Family />
      <Feedback />
    </>
  );
}

export default index;
